  <template>
  <v-form ref="form" v-model="valid">
    <v-text-field
      tabindex="1"
      v-model="usuario.nome"
      :rules="nomeRules"
      label="Nome:"
      type="text"
      id="usuario-nome"
      validate-on-blur
      class="input-required"
      @input="returnUsuario();"
      :mask="mask.nome"
      clearable
      required
    ></v-text-field>

    <v-text-field
      tabindex="2"
      v-model="usuario.email"
      :rules="emailRules"
      label="E-mail: (Login)"
      type="email"
      id="usuario-email"
      class="input-required"
      validate-on-blur
      @blur="verificaDispEmail();"
      @input="returnUsuario();"
      clearable
      required
    ></v-text-field>

    <v-text-field
      tabindex="3"
      v-model="usuario.telefone"
      label="Telefone:"
      id="usuario-telefone"
      class="input-required"
      validate-on-blur
      :type="'text'"
      mask="(##) ##### - ####"
      @input="returnUsuario();"
      clearable
      required
    ></v-text-field>

    <v-text-field
      tabindex="3"
      v-model="usuario.password"
      :rules="passRules"
      label="Senha:"
      id="usuario-password"
      class="input-required"
      validate-on-blur
      :append-icon="showPassword ? 'visibility_off' : 'visibility'"
      :type="showPassword ? 'text' : 'password'"
      @click:append="showPassword = !showPassword"
      @input="returnUsuario();"
      clearable
      required
    ></v-text-field>

    <v-select
      v-model="planoSelecionado"
      :hint="`Todos os planos possuem 7 dias gratuitos para teste`"
      :items="planos"
      id="usuario-planos"
      item-text="text"
      item-value="_ids"
      :rules="passRules"
      label="Planos"
      @change="returnUsuario()"
      persistent-hint
      return-object
      single-line
    ></v-select>

<!-- { type: 'T', text: "Telefone", item_id: 'telefone', valor: null, prepIcon: 'phone', class: null, mask: "(##) ##### - ####" } -->


  </v-form>
</template>

<script>
//URL PARA BUSCAR SE EMAIL JÁ CONSTA NO SISTEMA: usuarios?email=diego.humberto@compila.com.br
import Usuario from "@/domain/conta/usuario/Usuario.js";
import { arrayPlanos } from "@/domain/planos/planos.js";
export default {
  data: () => ({
    valid: false,
    usuario: new Usuario(),
    showPassword: false,
    mask: { nome: "" },
    planoSelecionado: null,
    resource: "",
    nomeRules: [
      v => !!v || "Campo obrigatório",
      v => /^[a-zA-Z _-]{1,90}$/.test(v) || "Digite um nome válido"
    ],
    // [a-zA-Z _-]+$
    emailRules: [
      v => !!v || "Campo obrigatório",
      v =>
        /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/.test(v) ||
        "Digite um e-mail válido"
    ],
    passRules: [v => !!v || "Campo é obrigatório"],
    planos: arrayPlanos
  }),
  computed: {},
  mounted: function() {
    this.$nextTick(function() {
      // SUPER  PERFORMANCE MICRO GESTÃO
      let urlPlano = this.$route.query.plano
        ? this.$route.query.plano.toLowerCase()
        : undefined;
      if (urlPlano) {
        urlPlano == "gestão" ? (urlPlano = urlPlano.replace(/ã/g, "a")) : "";

        this.planos.filter((a, b) => {
          if (a._id == urlPlano) {
            this.planoSelecionado = a;
          }
        });
      }
    });
  },
  methods: {
    verificaDispEmail: function() {
      if (this.$refs.form.$el[1].validity.valid) {
        this.resource = this.$resource("usuarios?email=" + this.usuario.email);
        this.resource.query().then(
          success => {
            this.emailRules.push(function indisponível(value) {
              if (value == success.body.items[0].email) {
                return "Email já utilizado no sistema";
              }
              return true;
            });
            this.$refs.form.validate();
          },
          failed => {
            if (failed.status == 404) {
              this.returnUsuario();
            }
          }
        );
      }
      return false;
    },
    returnUsuario: function() {
      if (this.verificaCampos()) {
        this.usuario.plano = this.planoSelecionado._id;
        return this.$emit("getUsuario", this.usuario);
      } else {
        return this.$emit("getUsuario", false);
      }
    },
    verificaCampos: function() {
      var cont = 0;
      var fields = [
        document.querySelector("#usuario-nome"),
        document.querySelector("#usuario-email"),
        document.querySelector("#usuario-password"),
        document.querySelector("#usuario-planos"),
        document.querySelector("#usuario-telefone")
      ];

      document.querySelector("#usuario-planos").value = " ";

      fields.forEach(item => {
        if (item.value != null && item.value != "") {
          cont++;
        }
      });

      if (cont === fields.length) {
        if (this.$refs.form.validate()) return true;
      }
      return false;
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/conta/precadastro/Usuario.vue